module.exports = __webpack_public_path__ + "media/images/spinner/Spinner-1s-194px-edd81e272f0c68578cc407e8e6a8c41b.gif";